module.exports = __webpack_public_path__ + "img/Karriere_Hintergrund.b1958fda.jpg";